import { api } from "@/lib/axios";

interface servicesProps {
  id: string;
  serviceName: string;
  price: number;
  serviceQuantity: number;
  buildingsId?: string;
}

interface ServicesResponse {
  services: servicesProps[];
  totalPages: number;
  totalServices: number;
  page: number;
}

export async function getServices(
  page = 1,
  pageSize = 8,
  serviceName?: string,
  buildingsId?: string,
) {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page.toString());
  queryParams.append("pageSize", pageSize.toString());

  if (serviceName !== undefined) {
    queryParams.append("serviceName", serviceName);
  }

  if (buildingsId !== undefined) {
    queryParams.append("buildingId", buildingsId);
  }

  const { data } = await api.get<ServicesResponse>(
    `/services?${queryParams.toString()}`,
  );

  return data;
}

// New function for dropdown
export async function getAllServices(buildingsId?: string) {
  const queryParams = new URLSearchParams();

  if (buildingsId !== undefined) {
    queryParams.append("buildingsId", buildingsId);
  }

  const { data } = await api.get<ServicesResponse>(
    `/services/all?${queryParams.toString()}`,
  );

  return data;
}
